import styled, { css } from 'styled-components';

import { SCROLLBAR_WIDTH } from '@web/consts/layout';

export type ScrollProps = {
  shouldApplyFallback?: boolean;
};
// @TODO allow passing custom props for colors if ever needed
export const scrollbarStyles = css<ScrollProps>`
  ${({ theme }) => css`
    --scrollbarWidth: ${SCROLLBAR_WIDTH}px;
    // RGBA - hex value of 50% opacity alpha channel
    --scrollbarThumbColor: ${`${theme.colors.iconGray}7A`};
    --scrollbarThumbInactiveColor: transparent;
    --scrollbarThumbHoverColor: ${theme.colors.iconGray};
    --scrollbarTrackColor: transparent;
  `};

  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-color: var(--scrollbarThumbInactiveColor) var(--scrollbarTrackColor);
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  transition: ease 0.25s scrollbar-color;

  &:hover {
    scrollbar-color: var(--scrollbarThumbHoverColor) var(--scrollbarTrackColor);
  }

  &::-webkit-scrollbar {
    height: var(--scrollbarWidth);
    width: var(--scrollbarWidth);
  }
  &::-webkit-scrollbar-track {
    background-color: var(--scrollbarTrackColor);
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: var(--scrollbarThumbColor);
  }
  &::-webkit-scrollbar-thumb {
    background-clip: content-box;
    background-color: var(--scrollbarThumbInactiveColor);
    border-radius: calc(var(--scrollbarWidth) / 2);
    border: 2px solid transparent;

    &:hover {
      background-color: var(--scrollbarThumbHoverColor);
    }
  }
`;

export const ScrollableContainer = styled.div<ScrollProps>`
  ${scrollbarStyles}
`;
